const config = {
  subtitle: `You can turn on subtitles while you're watching`,
  guidance: 'This programme includes a guidance warning',
  audioDesc: 'Audio-described (AD) content',
  signed: 'Visually-signed (BSL) content',
  svodExculsive: 'STV Player+ exclusive content',
  forceAds: 'This programme has ads because of contractual obligations',
}

export default config
